export default "__VITE_ASSET__DcGGRkco__"